import {
  buildUploadImage,
  uploadImageUsecase as _uploadImageUsecase,
} from "./upload-image";

import {
  buildDownloadFile,
  downloadFileUsecase as _downloadFileUsecase,
} from './download-file';

import StorageServiceRepository from "../../ports/storageServiceRepository";

// eslint-disable-next-line import/no-anonymous-default-export
export default (dependencies: {
  storageServiceRepo: StorageServiceRepository;
}): {
  uploadImage: _uploadImageUsecase;
  downloadFile: _downloadFileUsecase;
} => {
  const { storageServiceRepo } = dependencies;

  const uploadImage = buildUploadImage({ storageServiceRepo });
  const downloadFile = buildDownloadFile({ storageServiceRepo });

  return { uploadImage, downloadFile };
};

export type uploadImageUsecase = _uploadImageUsecase;
export type downloadFileUsecase = _downloadFileUsecase;
